import styled from "@emotion/styled";
import { LocalDateTime } from "@js-joda/core";
import * as React from "react";
import ClockInOutFooter from "./ClockInOutFooter";

interface Props {
  canClockIn: boolean;
  canClockOut: boolean;
  canSubmitTimesheet: boolean;
  clockInDateTime: LocalDateTime | null;
  onClockIn: () => void;
  onClockOut: () => void;
  onSubmitTimesheet: () => void;
}

const ClockButtonWrapper = styled.div<{ canClockIn: boolean; canClockOut: boolean }>`
  .ClockInButton {
    animation: ${(props) => (props.canClockIn ? "pulse 2s ease infinite" : "none")};
  }
  .ClockOutButton {
    animation: ${(props) =>
      !props.canClockIn && props.canClockOut ? "pulse 2s ease infinite" : "none"};
  }
`;

const VisitInstanceScreenFooter = (props: Props) => {
  return (
    <ClockButtonWrapper canClockIn={props.canClockIn} canClockOut={props.canClockOut}>
      <ClockInOutFooter
        canClockIn={props.canClockIn}
        canClockOut={props.canClockOut}
        canSubmitTimesheet={props.canSubmitTimesheet}
        onClockIn={props.onClockIn}
        onClockOut={props.onClockOut}
        onSubmitTimesheet={props.onSubmitTimesheet}
        clockInDateTime={props.clockInDateTime}
        clockOutDateTime={null}
      />
    </ClockButtonWrapper>
  );
};

export default VisitInstanceScreenFooter;
